window.addEventListener("resize", function () {
    updateStylesOnResize();
})

document.addEventListener("DOMContentLoaded", (event) => {
    swiperProductRed();
    updateStylesOnResize();
});

function swiperProductRed() {
    var swiper = new Swiper(".mySwiper", {
        autoplay: {
            delay: 2500,
        },
        loop: true,
        navigation: {
            nextEl: ".prodRec-slider-next",
            prevEl: ".prodRec-slider-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 22,
            },
            1025: {
                slidesPerView: 4,
                spaceBetween: 22,
            }
        },
    });
}

function updateStylesOnResize() {
        const prodRecContainer = document.querySelector('.prodRec-slider-container');
        const productImageAll = prodRecContainer?.querySelectorAll('.product-image');
        const firstProductImage = productImageAll?.length > 0 && productImageAll[0];
        if(firstProductImage) {
            const prevButton = prodRecContainer?.querySelector('.prodRec-slider-prev');
            const nextButton = prodRecContainer?.querySelector('.prodRec-slider-next');
            const height = firstProductImage?.clientHeight;
            prevButton.style.top = `${Number(height)/2}px`
            nextButton.style.top = `${Number(height)/2}px`
        }
}
